/**
 * constants
 */
 export const MS_FOR_OVERALL_TIMEOUT_FTUE = 200000 // JUST ENOUGH TIME TO PASS THE WORSE CASE AND LET THE STUDENT TRY 2 TIMES
 export const MS_FOR_OVERALL_TIMEOUT_RETURNING_USER_ASSESSMENT = 160000 // JUST ENOUGH TIME TO PASS THE WORSE CASE AND LET THE STUDENT TRY 2 TIMES
 export const MS_TO_WAIT_BETWEEN_REMIND_STUDENT_TO_SPEAK = 6000 // TIME BETWEEN REMINDERS FOR STUDENT TO START SPEAKING.
 export const MAX_COUNT_TO_REMIND_STUDENT_TO_SPEAK = 3 // HOW MANY TIMES WE WANT TO REMIND THE STUDENT TO START SPEAKING.
 export const MS_TO_WAIT_BETWEEN_EVALUATE_FOR_VOLUME_PROBLEM = 3800 // TIME BETWEEN CHECKING IF IT'S TOO SOFT / TOO LOUD.
 export const MAX_COUNT_TO_EVALUATE_BEFORE_CALLING_TEACHER = 3 // HOW MANY TIMES WE WANT TO CHECK TOO SOFT / TOO LOUD BEFORE FAILING THE STUDENT.
 // THE NUMBER OF TIMES AN ACCEPTABLE VOLUME IS DETECTED TO PASS THE CHECK, THIS VALUE IS KIND OF
 // RELATIVE TO THE LENGTH OF PHRASE "WAKE UP SPOT", BUT ALSO KIND OF ARBITRARY. THIS NEEDS TO HAPPEN
 // WITHIN THE TIMEOUT OF MS_TO_WAIT_BETWEEN_VOLUME_EVALUATIONS.
export const PASSING_ACCEPTABLE_VOLUME_COUNT = 10

export const VOLUME_CHECK_EVENTS = {
    STUDENT_PROMPT_TO_SPEAK: "STUDENT_PROMPT_TO_SPEAK",
    TOO_SOFT: "STUDENT_TOO_SOFT",
    ALMOST_TOO_LOUD: "STUDENT_ALMOST_TOO_LOUD",
    TOO_LOUD: "STUDENT_TOO_LOUD",
    RETRY: "STUDENT_RETRY",
    NEITHER_SOFT_NOR_LOUD: "STUDENT_NEITHER_SOFT_NOR_LOUD",
    NO_VOLUME_DETECTED: "STUDENT_NO_VOLUME_DETECTED",
    CALLED_TEACHER: "CALLED_TEACHER",
    TEACHER_PROMPT_TO_SPEAK: "TEACHER_PROMPT_TO_SPEAK",
    TEACHER_TEST_STARTED: "TEACHER_TEST_STARTED",
    TEACHER_TEST_TOO_SOFT: "TEACHER_TOO_SOFT",
    TEACHER_TEST_ALMOST_TOO_LOUD: "TEACHER_ALMOST_TOO_LOUD",
    TEACHER_TEST_TOO_LOUD: "TEACHER_TOO_LOUD",
    TEACHER_NEITHER_SOFT_NOR_LOUD: "TEACHER_NEITHER_SOFT_NOR_LOUD",
    TEACHER_NO_VOLUME_DETECTED: "TEACHER_NO_VOLUME_DETECTED",
    TEACHER_TEST_SUCCESS: "TEACHER_TEST_SUCCESS",
    TEACHER_TEST_FAILED: "TEACHER_TEST_FAILED",
    TEACHER_RETRY: "TEACHER_RETRY",
}

export const PROGRESS_STATES = {
    INITIAL: 'initial',
    INTRODUCTION_SCREEN_1: 'introduction_screen_1',
    INTRODUCTION_SCREEN_2: 'introduction_screen_2',
    SPOT_TRANSITION_ON_SCREEN: 'explosion',
    SPOT_ON_SCREEN: 'introduce_spot',
    SPOT_ON_SCREEN_2: 'spot_sleeping',
    SPOT_WOKE_UP: 'student_wake_up_spot',
    SPOT_EXIT_SCREEN: 'spot_test_exist_speech'
}
export const SPEECH_VOLUME_CHECK_STATES = {
    INITIAL: 'initial',
    WAITING_FOR_INITIAL_SPEECH: 'waiting_for_initial_speech',
    ACTIVITY_IN_PROGRESS: 'activity_in_progress',
    ACTIVITY_COMPLETED: 'activity_completed'
}
export const PROGRESS_STATES_ORDER = [
    PROGRESS_STATES.INITIAL,
    PROGRESS_STATES.INTRODUCTION_SCREEN_1,
    PROGRESS_STATES.INTRODUCTION_SCREEN_2,
    PROGRESS_STATES.SPOT_TRANSITION_ON_SCREEN,
    PROGRESS_STATES.SPOT_ON_SCREEN,
    PROGRESS_STATES.SPOT_ON_SCREEN_2,
    PROGRESS_STATES.SPOT_WOKE_UP,
    PROGRESS_STATES.SPOT_EXIT_SCREEN
]
export const VOLUME_CHECK_MODE = {
    STUDENT:"STUDENT",
    TEACHER:"TEACHER"
}